import React, { Component } from "react";
import {
  apiAutomationissues,
  apiActionResend,
  apiVpsOptionAvailable,
  apiAutomationChangeVps,
  apiAutomationChangePassword,
  apiAutomationSolved,
} from "../../Service/api";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactTable from "react-table";
import "react-table/react-table.css";
import {
  Box,
  Paper,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Stack,
  Alert,
  IconButton,
  AppBar,
  Toolbar,
  CircularProgress,
  Slide,
} from "@mui/material";
import { Input, InputGroup, InputGroupText, InputGroupAddon } from "reactstrap";
import {
  Refresh,
  Replay10Outlined,
  Close,
  CloudSync,
  Cancel,
  Save,
  CheckCircle,
  SyncLock,
  VisibilityOff,
  Visibility,
} from "@mui/icons-material";
import dayjs from "dayjs";
import Select, { components } from "react-select";

const stylesListComent = {
  inline: {
    display: "inline",
  },
};

const stylesDialog = {
  appBar: {
    position: "relative",
    backgroundColor: "#03101e",
  },
  title: {
    marginLeft: 0,
    flex: 1,
    fontSize: 16,
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CustomOption = (props) => {
  const color = props.data.flag_auto === "1" ? "green" : "blue";

  return (
    <components.Option {...props}>
      <div style={{ color, display: "flex", alignItems: "center" }}>
        {props.data.label}
      </div>
    </components.Option>
  );
};

const defaultFilterMethod = (filter, row) => {
  const cellValue = String(row[filter.id]).toLowerCase();
  return cellValue.includes(filter.value.toLowerCase());
};

// const getCurrentFormattedDate = () => {
//   const now = new Date();
//   const yyyy = now.getFullYear();
//   const mm = String(now.getMonth() + 1).padStart(2, "0");
//   const dd = String(now.getDate()).padStart(2, "0");
//   // const hh = String(now.getHours()).padStart(2, "0");
//   // const min = String(now.getMinutes()).padStart(2, "0");
//   // const ss = String(now.getSeconds()).padStart(2, "0");

//   return `${yyyy}-${mm}-${dd}`;
// };
class IssuesPage extends Component {
  constructor(props) {
    super(props);
    this.reactTable = React.createRef();
    this.setPassword = React.createRef();
    this.state = {
      tableData: [],
      tableDisplay: [],
      filter: "",
      setOpenEdit: false,
      setOpenAddNew: false,
      openSuccess: false,
      openSuccessText: "",
      openValidation: false,
      titleValidation: "",
      titleBody: "",
      openAlertApprove: false,
      openAlertReject: false,
      selectAll: false,
      checked: [],
      selectRowData: [],
      openSelectedRow: false,
      dataTelegramAccountShow: [],
      left: [],
      right: [],
      checked_transfer: [],
      available: [],
      showLoadingReject: false,
      showLoadingApprove: false,
      showLoadingRejectAll: false,
      showLoadingSubmit: false,
      showLoading: false,
      dataDetail: "",
      submitLoading: false,
      note: "",
      loginInfo: "",
      openDialog: false,
      messageDetail: "",
      setOpenAlertDialog: false,
      itemRowSelected: {},
      optionVps: [],
      vpsSelected: null,
      openModalChangePassword: false,
      showPassword: false,
    };

    this.tableColumns = [
      {
        Header: "Time",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "created_at",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        width: 200,
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {dayjs(e.original.created_at).format("DD/MM/YYYY HH:mm:ss")}
          </Typography>
        ),
      },

      {
        Header: "Ticket Id",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "ticket_id",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.ticket_id === null ? "-" : e.original.ticket_id}
          </Typography>
        ),
      },
      {
        Header: "Action",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "action",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.action === null ? "-" : e.original.action}
          </Typography>
        ),
      },
      {
        Header: "Client ID",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "client_id",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.client_id === null ? "-" : e.original.client_id}
          </Typography>
        ),
      },

      {
        Header: "Status",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "status",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Cell: (e) => (
          <Typography
            component="span"
            variant="body2"
            style={{
              display: "inline-block",
            }}
          >
            {e.original.status === null ? "-" : e.original.status}
          </Typography>
        ),
      },
      {
        Header: "Action",
        headerStyle: { fontWeight: "bold", fontSize: 14 },
        accessor: "",
        style: {
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        width: 600,
        Cell: (e) => {
          const { message } = e.original;

          const isChangePasswordTrue =
            message && message.indexOf("After Change Password(true)") !== -1;

          // const original = created_at;
          // const currentFormattedDate = getCurrentFormattedDate();

          // const isDisabled = currentFormattedDate > original;
          const isDisabled = false;

          const handleResend = () => {
            if (isChangePasswordTrue) {
              this.doResendNewTicket(e.original);
            } else {
              this.doResend(e.original);
            }
          };

          const handleChangeVPS = () => {
            if (isChangePasswordTrue) {
              this.doChangeVPS(e.original);
            } else {
              this.doChangeVPS(e.original);
            }
          };

          const handleChangePassword = () => {
            if (isChangePasswordTrue) {
              this.doChangePassword(e.original);
            } else {
              this.doChangePassword(e.original);
            }
          };

          const handleSolved = () => {
            if (isChangePasswordTrue) {
              this.doSolved(e.original);
            } else {
              this.doSolved(e.original);
            }
          };

          return (
            <div>
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: isDisabled ? "grey" : "#3f51b5",
                }}
                startIcon={<Replay10Outlined style={{ color: "white" }} />}
                onClick={handleResend}
                disabled={isDisabled}
              >
                <Typography
                  variant="button"
                  style={{
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                >
                  Resend
                </Typography>
              </Button>
              &nbsp;
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: isDisabled ? "grey" : "green",
                }}
                startIcon={<CloudSync style={{ color: "white" }} />}
                onClick={handleChangeVPS}
                disabled={isDisabled}
              >
                <Typography
                  variant="button"
                  style={{
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                >
                  Change VPS
                </Typography>
              </Button>
              &nbsp;
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: isDisabled ? "grey" : "#060482",
                }}
                startIcon={<SyncLock style={{ color: "white" }} />}
                onClick={handleChangePassword}
                disabled={isDisabled}
              >
                <Typography
                  variant="button"
                  style={{
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                >
                  Change Password
                </Typography>
              </Button>
              &nbsp;
              <Button
                variant="contained"
                size="small"
                style={{
                  backgroundColor: isDisabled ? "grey" : "orange",
                }}
                startIcon={<CheckCircle style={{ color: "white" }} />}
                onClick={handleSolved}
                disabled={isDisabled}
              >
                <Typography
                  variant="button"
                  style={{
                    color: "#fff",
                    textTransform: "capitalize",
                  }}
                >
                  Solved
                </Typography>
              </Button>
            </div>
          );
        },
      },
    ];
    this.noteInputRef = React.createRef();
  }

  componentDidMount() {
    let loginInfo = localStorage.getItem("loginInfo");
    loginInfo = JSON.parse(loginInfo);
    this.setState({
      loginInfo: loginInfo,
    });
    this.doLoadData();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  doLoadData = () => {
    this.props.doLoading();
    apiAutomationissues()
      .then((res) => {
        this.props.doLoading();
        let data = res.data;
        if (data.code === 200) {
          if (data.records.length > 0) {
            const temp = data.records;

            this.setState({
              tableData: temp,
            });
          } else {
            this.setState({
              tableData: [],
            });
          }
        } else {
          this.setState({
            tableData: [],
          });
        }
      })
      .catch((err) => {
        this.props.doLoading();
        console.log(err);
      });

    apiVpsOptionAvailable()
      .then((res) => {
        const data = res.data;
        if (data.status === "OK") {
          const optionVps = data.records.map((vps) => {
            return {
              value: vps.value,
              label: `${vps.label} (${
                vps.flag_auto === "1" ? "Auto" : "Manual"
              }) - ${vps.available} available`,
              vps_name: vps.vps_name,
              flag_auto: vps.flag_auto,
              available: vps.available,
            };
          });

          const filteredOptionVps = optionVps.filter(
            (vps) => vps.flag_auto === "1" && vps.available !== 0
          );
          // console.info("optionVps: ", filteredOptionVps);

          this.setState({
            optionVps: filteredOptionVps,
          });
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  };

  pressReset = () => {
    this.setState({
      openSuccess: false,
      openSuccessText: "",
    });
    this.doLoadData();
  };

  handleClickOpen = (message) => {
    this.setState({ openDialog: true, messageDetail: message });
  };

  handleClose = () => {
    this.setState({ openDialog: false, messageDetail: "" });
  };

  doResendNewTicket = (item) => {
    console.log("item resend new ticket: ", item);
  };

  doChangeVPS = (item) => {
    // console.log("item change vps: ", item);
    this.setState({
      setOpenAlertDialog: true,
      itemRowSelected: item,
    });
  };

  doChangePassword = (item) => {
    // console.log("item change password: ", item);

    this.setState({
      openModalChangePassword: true,
      itemRowSelected: item,
    });
  };

  handleCloseOpenAlertDialog = () => {
    this.setState({
      setOpenAlertDialog: false,
      openModalChangePassword: false,
      itemRowSelected: {},
      vpsSelected: null,
    });
  };

  doResend = (item) => {
    // console.log("item resend: ", item);

    this.props.doLoading();

    apiActionResend(item)
      .then((res) => {
        // console.info(res);
        this.props.doLoading();
        const data = res.data;
        if (data.status === "success") {
          this.setState({
            openSuccess: true,
            openSuccessText: `Successfully resend ticket ${item.ticket_id}`,
          });
        } else {
          this.setState({
            openSuccess: true,
            openSuccessText: data.message,
          });
        }
      })
      .catch((err) => {
        this.props.doLoading();

        console.error(err);
      });
  };

  checkDataPassword = () => {
    const { itemRowSelected } = this.state;

    const password =
      (this.setPassword.current && this.setPassword.current.value) || "";
    if (password === "") {
      this.setState({
        openValidation: true,
        titleValidation: "Password Required",
        titleBody: "Please enter your password.",
      });
    } else {
      const payload = {
        password: password,
        ticket_id: itemRowSelected.ticket_id,
      };

      this.props.doLoading();
      this.setState({
        submitLoading: true,
      });

      apiAutomationChangePassword(payload)
        .then((res) => {
          this.setState({
            submitLoading: false,
          });
          this.props.doLoading();
          const data = res.data;
          if (data.code === 200) {
            this.setState({
              openSuccess: true,
              openSuccessText: `Successfully changed the password for ticket ${itemRowSelected.ticket_id}.`,
            });
          } else {
            this.setState({
              openSuccess: true,
              openSuccessText: data.message,
            });
          }
          this.handleCloseOpenAlertDialog();
        })
        .catch((err) => {
          this.setState({
            submitLoading: false,
          });
          this.props.doLoading();

          console.error(err);
        });
    }
  };

  checkData = () => {
    const { vpsSelected, itemRowSelected } = this.state;
    const payload = {
      vps_id: vpsSelected.value,
      ticket_id: itemRowSelected.ticket_id,
    };

    this.props.doLoading();
    this.setState({
      submitLoading: true,
    });

    apiAutomationChangeVps(payload)
      .then((res) => {
        this.setState({
          submitLoading: false,
        });
        // console.info(res);
        this.props.doLoading();
        const data = res.data;
        if (data.code === 200) {
          this.setState({
            openSuccess: true,
            openSuccessText: `Successfully change the VPS for ticket ${itemRowSelected.ticket_id}`,
          });
        } else {
          this.setState({
            openSuccess: true,
            openSuccessText: data.message,
          });
        }
        this.handleCloseOpenAlertDialog();
      })
      .catch((err) => {
        this.setState({
          submitLoading: false,
        });
        this.props.doLoading();

        console.error(err);
      });

    // console.log("vpsSelected: ", vpsSelected);
    // console.log("itemRowSelected: ", itemRowSelected);
  };

  doSolved = (item) => {
    const payload = {
      ticket_id: item.ticket_id,
    };

    this.props.doLoading();

    apiAutomationSolved(payload)
      .then((res) => {
        this.props.doLoading();
        const data = res.data;
        if (data.code === 200) {
          this.setState({
            openSuccess: true,
            openSuccessText: `Ticket ${item.ticket_id} or account number ${item.account_number} has been successfully solved.`,
          });
        } else {
          this.setState({
            openSuccess: true,
            openSuccessText: data.message,
          });
        }
        this.handleCloseOpenAlertDialog();
      })
      .catch((err) => {
        this.props.doLoading();

        console.error(err);
      });
  };

  handleChangeVps = (vps) => {
    this.setState({
      vpsSelected: vps,
    });
  };

  renderDialog = () => {
    return (
      <Dialog
        open={this.state.openDialog}
        onClose={this.handleClose}
        aria-labelledby="message-dialog-title"
        aria-describedby="message-dialog-description"
      >
        <DialogTitle id="message-dialog-title">Message Detail</DialogTitle>
        <DialogContent>
          <DialogContentText id="message-dialog-description">
            {this.state.messageDetail === ""
              ? "No message"
              : this.state.messageDetail}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  renderDialogAlert = () => {
    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={this.state.setOpenAlertDialog}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography variant="h5" style={stylesDialog.title}>
              Are you sure you want to change the VPS for this auto-assigned
              ticket ID {this.state.itemRowSelected.ticket_id}?
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseOpenAlertDialog()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent dividers>
          <Box sx={{ flexGrow: 1 }} style={{ marginBottom: 60, marginTop: 20 }}>
            <Grid container spacing={2}>
              <Grid item lg={2} md={3} sm={3} xs={12}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  VPS
                </Typography>
              </Grid>
              <Grid item lg={10} md={9} sm={9} xs={12}>
                <Select
                  classNamePrefix="select"
                  placeholder="Select a vps"
                  value={this.state.vpsSelected}
                  onChange={this.handleChangeVps}
                  options={this.state.optionVps}
                  components={{ Option: CustomOption }}
                  styles={{
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition={"fixed"}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#d0021b",
            }}
            startIcon={<Cancel />}
            onClick={() => this.handleCloseOpenAlertDialog()}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>
          &nbsp;&nbsp;
          <Button
            disabled={this.state.submitLoading}
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#004dcf",
            }}
            startIcon={<Save />}
            onClick={() => this.checkData()}
          >
            {this.state.submitLoading === true ? (
              <CircularProgress style={{ color: "#fff" }} size={24} />
            ) : (
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Submit
              </Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  handleTogglePassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  renderModalChangePassword = () => {
    return (
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={this.state.openModalChangePassword}
        fullWidth={true}
        maxWidth="md"
      >
        <AppBar style={stylesDialog.appBar}>
          <Toolbar>
            <Typography variant="h5" style={stylesDialog.title}>
              Are you sure you want to change the password for this
              auto-assigned ticket ID {this.state.itemRowSelected.ticket_id}?
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => this.handleCloseOpenAlertDialog()}
              aria-label="close"
            >
              <Close />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent dividers>
          <Box sx={{ flexGrow: 1 }} style={{ marginBottom: 60, marginTop: 20 }}>
            <Grid container spacing={2}>
              <Grid item lg={2} md={3} sm={3} xs={12}>
                <Typography
                  component="span"
                  variant="subtitle1"
                  style={{
                    float: "left",
                    marginTop: 6,
                    textTransform: "capitalize",
                  }}
                >
                  Password
                </Typography>
              </Grid>
              <Grid item lg={10} md={9} sm={9} xs={12}>
                <InputGroup>
                  <Input
                    autoComplete="off"
                    type={this.state.showPassword ? "text" : "password"}
                    name="password"
                    id="password"
                    innerRef={this.setPassword}
                  />
                  <InputGroupAddon addonType="append">
                    <InputGroupText>
                      <span onClick={this.handleTogglePassword}>
                        {this.state.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </span>
                    </InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#d0021b",
            }}
            startIcon={<Cancel />}
            onClick={() => this.handleCloseOpenAlertDialog()}
          >
            <Typography
              variant="button"
              style={{
                color: "#fff",
                textTransform: "capitalize",
              }}
            >
              Cancel
            </Typography>
          </Button>
          &nbsp;&nbsp;
          <Button
            disabled={this.state.submitLoading}
            variant="contained"
            size="large"
            style={{
              backgroundColor: "#004dcf",
            }}
            startIcon={<Save />}
            onClick={() => this.checkDataPassword()}
          >
            {this.state.submitLoading === true ? (
              <CircularProgress style={{ color: "#fff" }} size={24} />
            ) : (
              <Typography
                variant="button"
                style={{
                  color: "#fff",
                  textTransform: "capitalize",
                }}
              >
                Submit
              </Typography>
            )}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  renderSuccess = () => {
    if (this.state.openSuccess === true) {
      setTimeout(() => this.pressReset(), 2000);

      return (
        <div style={{ margin: 10 }}>
          <Stack sx={{ width: "100%" }} spacing={2}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton aria-label="close" color="inherit" size="small">
                  <Close fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              {this.state.openSuccessText}
            </Alert>
          </Stack>
        </div>
      );
    }
  };

  handleCloseValidationAlert = () => {
    this.setState({
      openValidation: false,
      titleValidation: "",
      titleBody: "",
    });
  };

  renderValidationAlert = () => {
    return (
      <Dialog
        open={this.state.openValidation}
        onClose={this.handleCloseValidationAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          <div className="label-title-alert">{this.state.titleValidation}</div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <div className="title-body-alert"> {this.state.titleBody} </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <IconButton
            style={{ backgroundColor: "#f2f2f2" }}
            onClick={this.handleCloseValidationAlert}
          >
            <Close />
          </IconButton>
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    return (
      <Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Paper
                style={{
                  borderLeft: 6,
                  borderColor: "#2f55a2",
                  color: "#FFF",
                  maxHeight: 100,
                  padding: 16,
                  paddingBottom: 24,
                }}
              >
                <Grid container spacing={1}>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <Typography
                      component="span"
                      variant="h1"
                      style={
                        (stylesListComent.inline,
                        {
                          fontSize: 20,
                          color: "#000",
                          fontWeight: "bold",
                        })
                      }
                    >
                      Automation Issues
                    </Typography>
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <div className="contentDate">
                      <div style={{ marginRight: 0 }}>
                        <Button
                          variant="contained"
                          size="small"
                          style={{
                            backgroundColor: "#1273DE",
                          }}
                          startIcon={<Refresh />}
                          onClick={() => this.pressReset()}
                        >
                          <Typography
                            variant="button"
                            style={{
                              color: "#fff",
                              textTransform: "capitalize",
                            }}
                          >
                            Refresh
                          </Typography>
                        </Button>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
        {this.renderSuccess()}
        <br></br>
        <div className="box-container">
          <ReactTable
            ref={(r) => (this.reactTable = r)}
            data={this.state.tableData}
            columns={this.tableColumns}
            style={{ backgroundColor: "#f2f2f2" }}
            filterable
            defaultFilterMethod={defaultFilterMethod}
            defaultPageSize={500}
            showPageJump={false}
            showPageSizeOptions={false}
            showPagination={false}
            SubComponent={(row) => {
              return (
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "5px",
                    fontSize: "14px",
                    lineHeight: "1.5",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      fontWeight: "bold",
                      marginBottom: "10px",
                    }}
                  >
                    Details:
                  </Typography>
                  <ul style={{ paddingLeft: "20px", margin: 0 }}>
                    <li style={{ marginBottom: "5px" }}>
                      <strong>VPS:</strong>{" "}
                      {row.original.vps_name === null
                        ? "-"
                        : `${row.original.vps_id_response} - (${row.original.vps_name_response})`}
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      <strong>Account:</strong>{" "}
                      {row.original.account_number === null
                        ? "-"
                        : `${row.original.account_number}`}
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      <strong>Lot:</strong>{" "}
                      {row.original.lot === null || row.original.lot === ""
                        ? "-"
                        : row.original.lot}
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      <strong>Response Time:</strong>{" "}
                      {row.original.response_time === null
                        ? "-"
                        : dayjs(row.original.response_time).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                    </li>
                    <li style={{ marginBottom: "5px" }}>
                      <strong>Status:</strong>{" "}
                      {row.original.status === null
                        ? "-"
                        : `${row.original.status}`}
                    </li>
                    <li>
                      <strong>Message:</strong>{" "}
                      {row.original.message === null
                        ? "-"
                        : `${row.original.message}`}
                    </li>
                  </ul>
                </div>
              );
            }}
          />
        </div>

        {this.renderDialog()}
        {this.renderDialogAlert()}
        {this.renderModalChangePassword()}
        {this.renderValidationAlert()}
      </Box>
    );
  }
}
export default IssuesPage;
